import { ButtonGroup, ButtonGroupProps } from '@chakra-ui/react'

export type { ButtonGroupProps }

export default ButtonGroup
